import { z } from 'zod';
import { SanityDocumentSchema, SanityBlockSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';

export const ModalTextSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.ModalText),
  body: z.array(SanityBlockSchema).optional()
});

export type ModalText = z.infer<typeof ModalTextSchema>;
